import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonDialogData } from '../../models/dialog.model';
/**
 * CommonDialogComponent
 * This component is responsible for rendering a reusable dialog that can be used
 * to display common messages, warnings, or confirmations. It is designed to
 * handle dynamic data passed via the `MAT_DIALOG_DATA` token.
 */
@Component({
  selector: 'app-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrl: './common-dialog.component.scss'
})
export class CommonDialogComponent {
  /**
   * Constructor of the CommonDialogComponent.
   * 
   * @param data - Injected dialog data passed via MAT_DIALOG_DATA.
   * This data is used to populate the dialog content dynamically.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CommonDialogData
  ) { }
}

